<template>
  <section class="scene">
    <!-- people -->
    <img alt="Mage" src="@/assets/images/people/mage/left/stand/0.png" class="person person--mage">
    <img alt="Piggy" src="@/assets/images/people/piggy.png" class="person person--piggy">
    <!-- content -->
    <!--
    <div class="content content--top">
      <div class="container">
        <h2 class="title">
          Millions of players ...
        </h2>
      </div>
    </div>
    -->
  </section>
</template>

<script>
export default {
  name: 'VillageFriends'
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/mixins.scss';

.person--mage {
  width: 230px;
  bottom: -84px;
  left: 40%;

  @include breakpoint(sm) {
    left: 30%;
  }
}
.person--piggy {
  display: none;
  bottom: 75px;
  left: 80%;

  @include breakpoint(sm) {
    display: block;
  }
}
</style>
